<template>
	<section class="watchlist-banner">
		<div
			class="bg-white rounded-2xl py-10 px-6 relative overflow-hidden"
			style="box-shadow: 0 4px 30px 0 rgba(37, 59, 102, 0.25)"
		>
			<!-- Background gradient blur effect -->
			<img
				src="/images/gradient-cutout.png"
				alt="Gradient Cutout"
				class="absolute bottom-0 right-0 pointer-events-none h-[296px] w-[296px] lg:block hidden"
			/>

			<!-- Main content -->
			<div class="relative z-10 max-w-[642px]">
				<!-- Headline -->
				<h2
					class="text-3xl lg:text-4xl text-black leading-tight mb-6 max-w-2xl title-font"
				>
					Want To See Tomorrow's
					<br clear="hidden lg:block" />
					Stock Winners
					<span class="gradient-text font-bold">Today?</span>
				</h2>

				<!-- Description -->
				<p class="text-lg text-gray-700 mb-8 max-w-2xl text-slate-500">
					Our Oracle Algorithm scans 15,000 stocks every second and just alerted
					12,000+ traders to 16 stocks with 50%+ gains this month.
				</p>

				<!-- Testimonials Section -->
				<div class="mb-8">
					<h3
						class="text-xs lg:text-sm font-bold text-gray-700 uppercase tracking-wider mb-4 text-slate-500"
					>
						USED BY MILLIONAIRE TRADERS & ANALYSTS:
					</h3>

					<div class="flex flex-col sm:flex-row gap-6">
						<!-- Tim Bohen -->
						<div class="flex items-center text-left gap-3">
							<img
								src="/images/tbohen.png"
								alt="Tim Bohen"
								class="object-cover w-10 h-10 rounded-full"
							/>

							<div>
								<h4 class="font-bold text-black text-sm">Tim Bohen</h4>
								<p class="text-gray-600 text-xs text-slate-500">$1M+ trader</p>
							</div>
						</div>

						<!-- Matt Monaco -->
						<div class="flex items-center text-left gap-3">
							<img
								src="/images/mmonaco.png"
								alt="Matt Monaco"
								class="object-cover w-10 h-10 rounded-full"
							/>

							<div>
								<h4 class="font-bold text-black text-sm">Matt Monaco</h4>
								<p class="text-gray-600 text-xs text-slate-500">$2M by age 26</p>
							</div>
						</div>

						<!-- Bryce Tuohey -->
						<div class="flex items-center text-left gap-3">
							<img
								src="/images/btuohey.png"
								alt="Bryce Tuohey"
								class="object-cover w-10 h-10 rounded-full"
							/>

							<div>
								<h4 class="font-bold text-black text-sm">Bryce Tuohey</h4>
								<p class="text-gray-600 text-xs text-slate-500">
									College dropout turned millionaire
								</p>
							</div>
						</div>
					</div>
				</div>

				<NuxtLink
					to="https://sttlive.io/cnfCzx/"
					class="custom-cta-button group flex md:inline-flex items-center justify-center px-8 py-4 rounded-xl font-bold text-lg text-white transition-all duration-200 transform hover:scale-101 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2"
				>
					<span class="flex items-center">
						<span class="hidden lg:inline-block">
							Sign me up for FREE Trade Alerts
						</span>
						<span class="inline-block lg:hidden">Get Free Alerts</span>
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M14 4.92993L12.5 6.42993L17.0703 11.0002H3V13.0002H17.0703L12.5 17.5706L14 19.0706L21.0703 12.0002L14 4.92993Z"
								fill="white"
							/>
						</svg>
					</span>
				</NuxtLink>
			</div>
		</div>
	</section>
</template>

<script setup>
import { breakpointsTailwind } from "@vueuse/core";

const breakpoints = useBreakpoints(breakpointsTailwind);
const isDesktop = computed(() => breakpoints.isGreaterOrEqual("lg"));
</script>

<style scoped>
.watchlist-banner {
	padding: 2px;
}

/* Custom gradient text with bottom border */
.gradient-text {
	background: linear-gradient(to right, #0d0d12 0%, #0057ff 46%, #de59ff 83%);
	-webkit-background-clip: text;
	background-clip: text;
	-webkit-text-fill-color: transparent;
	position: relative;
}

.gradient-text::after {
	content: "";
	position: absolute;
	bottom: -2px;
	left: 0;
	width: 100%;
	height: 2px;
	background: linear-gradient(to right, #0d0d12 0%, #0057ff 46%, #de59ff 83%);
}

.custom-cta-button {
	box-shadow: 0 4px 15px 0 rgba(37, 59, 102, 0.2);
	background: linear-gradient(to right, #60a5fa, #a855f7);
}

.custom-cta-button:hover {
	background: linear-gradient(to right, #50b5ff 0%, #be55ff 99.95%);
	box-shadow: 0 6px 20px 0 rgba(37, 59, 102, 0.3);
}

.custom-cta-button:focus {
	box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.5);
}

.custom-cta-button:hover {
	background-position: right center;
}
</style>
